"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = { class: "cursor-pointer inline-flex items-center" };
const _hoisted_4 = ["data-text"];
const _hoisted_5 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "font-bold" };
const _hoisted_8 = {
    key: 2,
    class: "font-bold"
};
const productPopupStore_1 = require("../../../stores/productPopup/productPopupStore");
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NameCell',
    props: {
        product: null
    },
    setup(__props) {
        const productPopupStore = (0, productPopupStore_1.useProductPopupStore)();
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.nameColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `name-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('name', 'Name', 'name_cell')), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", {
                            class: "pr-3 flex justify-center items-center textbox textbox-right",
                            "data-text": (0, vue_2.unref)(i18n_1.trans)('product_info', 'Product info', 'name_cell')
                        }, [
                            (0, vue_2.createElementVNode)("span", {
                                class: "icon marso-icon-info-circle text-2xl text-blue",
                                onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(productPopupStore).beginProcess(__props.product)))
                            })
                        ], 8, _hoisted_4),
                        (__props.product.type === 'valve')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, (0, vue_2.toDisplayString)(__props.product.productName), 1))
                            : ((0, vue_2.unref)(tagStore).tags.columns.nameColumn.value === 'tyre')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(__props.product.brandName), 1),
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(__props.product.treadCode), 1)
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, (0, vue_2.toDisplayString)(__props.product.productName), 1))
                    ])
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
